<template>
<div id="app_mobil">
  <br>
  <v-container fluid fill-height>
    <v-row align-center justify-center>
      <v-col xs="12">
        <base-material-card color="primary" icon="library_books" title="Busqueda de Carta Porte" class="elevation-1 px-5 py-3">
          <!-- <v-card-actions>
            <UploadExcel title="Importar Layout" idInput="articulosKey" :on-success="handleSuccess" :before-upload="beforeUpload" :firstRow="2" />
          </v-card-actions> -->
          <v-card-text>
            <div class="busqueda">
              <v-row>
                <v-col sm="12">
                  <v-text-field v-model="model.numero" label="Clave" :rules="[rules.required]"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col sm="6">
                  <v-btn block class="ma-2" outlined color="indigo" @click.native="buscar"> Buscar </v-btn>
                </v-col>
                <!-- <v-col sm="6" v-if="encontrado">
                  <v-btn block class="ma-2" outlined color="indigo"> Outlined Button </v-btn>
                </v-col> -->
              </v-row>
            </div>
            <div class="">
              <pdf :src="item.pdf"></pdf>
            </div>
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</div>
</template>



<script>
import moment from "moment";
import axios from "axios";
import pdf from 'vue-pdf'

export default {
  name: "appMobil",
  components: {
    pdf
  },

  created: function() {
    this.model = this.clean_model();
    this.rules = this.$rules;
  },
  data: () => ({
    item: {},
    rules: {},
    modal: false,
    model: {},
    search: undefined,
    encontrado: false,
    api: "carta_porte/transportista/"
  }),
  methods: {
    clean_model: function() {
      return {
        numero: ""
      };
    },
    buscar: function() {
      if (this.model.numero != "" && this.model.numero != undefined) {
        this.$root.$dialogLoader.show("Espere un momento por favor..");

        let tel = this.model.numero;

        axios.post(this.$hostname+this.api, {
            "tel": tel
          })
          .then((res) => {
            this.item = res.data;
            this.encontrado = true;
            this.$root.$dialogLoader.hide();
          })
          .catch((error) => {

            this.$swal({
              type: "error",
              title: "Error",
              text: error.response.data.mensaje,
              footer: "",
            });

            this.$root.$dialogLoader.hide();

          });
      } else {
        this.$swal({
          type: "error",
          title: "Error",
          text: "Debes ingresar tu número de telefono",
          footer: "",
        });
      }
    }
  },
};
</script>
